import { either } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { ModelVersionsContext } from 'modules/Models/components/ModelVersionsContext/ModelVersionsContext';
import { ReactLeft, reactLeftToJSX } from 'utils/uiStates/uiStates';

type ModelVersionsContextProviderProps = {
  modelVersionsE: either.Either<ReactLeft, CF.API.Models.ListModelVersions.Response>;
};

export const ModelVersionsContextProvider: React.FC<ModelVersionsContextProviderProps> = ({ modelVersionsE, children }) =>
  pipe(
    modelVersionsE,
    either.fold(reactLeftToJSX(undefined, { showErrorCTA: true }), (modelVersions) => (
      <ModelVersionsContext.Provider value={modelVersions.model_versions}>{children}</ModelVersionsContext.Provider>
    )),
  );
